// extracted by mini-css-extract-plugin
module.exports = {"carNumberPlaceHolder":"CarNumber_carNumberPlaceHolder__3wAJr"};